import { render, staticRenderFns } from "./ActivationPanel.vue?vue&type=template&id=163db418&scoped=true"
import script from "./ActivationPanel.vue?vue&type=script&lang=js"
export * from "./ActivationPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivationPanel.vue?vue&type=style&index=0&id=163db418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163db418",
  null
  
)

export default component.exports